module.exports = __webpack_public_path__ + "img/volgograd-panorama.ff80055a.jpg";